export const items = {
  data() {
    return {
      items: [
        {
          name: "Dashboard",
          icon: "dashboard",
        },
        {
          name: "Courses",
          icon: "courses",
        },
        {
          name: "Friends",
          icon: "friends",
        },
        {
          name: "Schedule",
          icon: "schedule",
        },
        {
          name: "Message",
          icon: "message",
        },
        {
          name: "Achievment",
          icon: "achievment",
        },
        {
          name: "Settings",
          icon: "settings",
        }
      ],
    }
  },
}